<template>
  <div id="content">

    <div id="nav">
      <div
        :class="item.name===this.$store.state.currentTabPage ? 'nav_item block_center nav_item_bg' :'nav_item block_center' "
        v-for="item in tabData"
        :key="item" @click="handlerTabRoute(item)">
        <div class="tab_txt" >
          <p v-if="iconMap[item.enName] == undefined">{{ item.enName }}</p>
          <img style="width: 15.2rem; height: 11.1rem;" v-if="iconMap[item.enName]" :src="item.name===this.$store.state.currentTabPage ? iconMapSelected[item.enName] : iconMap[item.enName]">
        </div>
        <div v-if="item.footmarkPaperEn" class="nav_tip_contain">
          <p>{{ item.footmarkPaperEn }}</p>
        </div>
      </div>
    </div>
    <div id="home">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { NavigationFailureType, isNavigationFailure } from 'vue-router'
import bus from 'vue3-eventbus'

export default {
  props: {
    tabData: Array
  },
  data () {
    return {
      iconMap: {
        "Earn Money": require('@/assets/iv_earnmoney.png'),
        "My Cash": require('@/assets/iv_mycash.png'),
        "T&C": require('@/assets/iv_help.png'),
        "Ranking":require('@/assets/iv_ranking.png'),
        "Upgrade Reward":require('@/assets/iv_upgrade.png')
      },
      iconMapSelected: {
        "Earn Money": require('@/assets/iv_earnmoney_selected.png'),
        "My Cash": require('@/assets/iv_mycash_selected.png'),
        "T&C": require('@/assets/iv_help_selected.png'),
        "Ranking":require('@/assets/iv_ranking_selected.png'),
        "Upgrade Reward":require('@/assets/iv_upgrade_selected.png')
      },
    }
  },
  created () {
    bus.on('main_navi', (name) => {
      for (const index in this.tabData) {
        const item = this.tabData[index]
        if (item.name === name) {
          this.handlerTabRoute(item)
          break
        }
      }
    })
  },
  methods: {
    async handlerTabRoute (tabData) {
      if (tabData.name === 'Earn Money') {
        const failure = await this.$router.push('/main/earn_cash/0')
        if (!isNavigationFailure(failure, NavigationFailureType.aborted)) {
          this.$store.commit('currentTabPage', tabData.name)
        }
        bus.emit('refresh', true)
      } else if (tabData.name === 'My Cash') {
        const failure = await this.$router.push('/main/my_cash')
        if (!isNavigationFailure(failure, NavigationFailureType.aborted)) {
          this.$store.commit('currentTabPage', tabData.name)
        }
      } else if (tabData.name === 'Upgrade Reward V2') {
        await this.$router.push({
          path: '/main/web',
          query: { url: 'upgrade_reward_v2.html' },
          param: { url: 'upgrade_reward_v2.html' }
        })
        this.$store.commit('currentTabPage', tabData.name)
      } else if (tabData.name === 'T&C') {
        await this.$router.push({
          path: '/main/web',
          query: { url: 'tc/t_c.html' },
          param: { url: 'tc/t_c.html' }
        })
        this.$store.commit('currentTabPage', tabData.name)
      } else if (tabData.name === 'Ranking') {
        await this.$router.push({
          path: '/main/web',
          query: { url: 'ranking.html' },
          param: { url: 'ranking.html' }
        })
        this.$store.commit('currentTabPage', tabData.name)
      } else if (tabData.name === 'Gullak') {
        await this.$router.push({
          path: '/main/web',
          query: { url: 'gullak.html' },
          param: { url: 'gullak.html' }
        })
        this.$store.commit('currentTabPage', tabData.name)
      } else if (tabData.name === 'Course') {
        await this.$router.push({
          path: '/main/web',
          query: { url: 'course.html' },
          param: { url: 'course.html' }
        })
        this.$store.commit('currentTabPage', tabData.name)
      } else {
        const failure = await this.$router.push({
          path: '/main/web',
          query: { url: tabData.enUrl },
          param: { url: tabData.enUrl }
        })
        if (!isNavigationFailure(failure, NavigationFailureType.aborted)) {
          this.$store.commit('currentTabPage', tabData.name)
        }
      }
    }
  }
}

</script>

<style scoped>

a {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的文字颜色 */
}

@media screen and (orientation: portrait) {
  #content {
    display: flex;
    width: 100%;
    height: 90%;
  }
}

@media screen and (orientation: landscape) {
  #content {
    display: flex;
    width: 100%;
    height: 90vh;
  }
}

#nav {
  width: 13%;
  height: 100%;
  overflow: scroll;
}

::-webkit-scrollbar {
  display: none;
}

#home {
  flex: 1;
  margin-left: 2rem;
}

.nav_item {
  width: 100%;
  height: 11.1rem;
  text-align: center;
  color: white;
  position: relative;
  font-size: 2.6rem;
  background-image: url("@/assets/nav_item_default_bg.png");
  background-size: 100% 100%;
  margin-top: 0.5rem;
}

.block_center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav_item_bg {
  background-image: url("@/assets/nav_item_bg.png");
  background-size: 100% 100%;
}
.tab_txt{
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  align-items: center;
  justify-items: center;
  flex-direction: column;
}
.tab_txt_selected{
  padding-left: 1rem;
  padding-right: 1rem;
}
.nav_tip_contain {
  background-image: url("@/assets/nav_item_tip.png");
  background-size: 100% 100%;
  width: 5rem;
  right: 0;
  top: 0;
  position: absolute;
  height: 2.5rem;
  display: flex;
  align-content: center;
  justify-content: center;
}

.nav_tip_contain > p {
  color: #B03900;
  font-size: 1.6rem;
  line-height: 2.5rem;
  font-weight: bolder;
  padding-left: 0.8rem;
}

</style>
